module.exports = __webpack_public_path__ + "static/media/reward.54b3a540.png";